import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Check } from "lucide-react";
import {
  usePlatformCurrency,
  SUPPORTED_PLATFORM_CURRENCIES,
  CURRENCY_LABELS,
} from "@/lib/platform-currency";
import { useI18n } from "@/lib/i18n";

export default function CurrencyToggle({ variant = "ghost", size = "sm", className = "" }) {
  const { currency, setCurrency, source } = usePlatformCurrency();
  const { lang } = useI18n();
  const [open, setOpen] = useState(false);

  const isAr = lang === "ar";
  const current = CURRENCY_LABELS[currency];

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant={variant}
          size={size}
          className={`gap-1.5 ${className}`}
          aria-label={isAr ? "تغيير العملة" : "Change currency"}
          aria-haspopup="listbox"
        >
          <span className="font-semibold text-xs tracking-wide">{currency}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56 z-50 bg-popover">
        <DropdownMenuLabel className="text-xs">
          {isAr ? "عملة عرض الأسعار" : "Display currency"}
          {source === "ip" && (
            <span className="block text-[10px] font-normal text-muted-foreground mt-0.5">
              {isAr ? "تم اكتشافها تلقائياً" : "Auto-detected"}
            </span>
          )}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {SUPPORTED_PLATFORM_CURRENCIES.map((code) => {
          const label = CURRENCY_LABELS[code];
          const active = code === currency;
          return (
            <DropdownMenuItem
              key={code}
              onClick={() => { setCurrency(code); setOpen(false); }}
              className="cursor-pointer"
            >
              <span className="flex-1 flex items-center gap-2">
                <span className="font-mono text-xs font-semibold w-10">{code}</span>
                <span className="text-sm">{isAr ? label.ar : label.en}</span>
              </span>
              {active && <Check className="h-4 w-4 text-primary" />}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}